<template>
    <div>
         <loader :show="enviando"/>
        <v-card flat>
            <v-card-text>
                <busqueda 
                    :empleados="empleadoSel"
                    :dependencias="dependenciaSel"
                    :puestos="puestoSel"
                    :localidades="localidades"
                    @enviandoStart="enviando=true"
                    @enviandoStop="enviando=false"
                />
            </v-card-text>

            <v-card-text v-if="puedeAgregar">
                <agregar 
                    :empleados="empleadoSel"
                    @enviandoStart="enviando=true"
                    @enviandoStop="enviando=false"
                />
            </v-card-text>

        </v-card>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios'
import Loader from '../../../components/Loader'
import Busqueda from './busqueda'
import Agregar from './agregar'


export default {
    name: 'Asistencias',
	components: {
        Busqueda,
        Agregar,
        Loader
	},
    computed: {
        ...mapGetters([ "sessionToken", "httpURL", "userId", "tableProps", "permisos", "role" ]),
        puedeAgregar(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 197) >= 0 ? true : false;
        },
    },
    data() {
        return {
            enviando:false,
            tab: null,
            busqueda: 'Empleado',
            busquedaSel: ['Empleado','Dependencia','Puesto','Cálculo de horarios'],
            empleado: null,
            dependencia: null,
            puesto: null,
            empleadoSel: [],
            dependenciaSel: [],
            puestoSel: [],
            localidades: []
        }
    },
    created(){
        this.enviando = true;
        axios.get(this.httpURL+'/asistencias/listados',{headers:{token: this.sessionToken}})
            .then(res => {
                // console.log(res);
                res.data.usuarios.forEach(element => {
                    this.empleadoSel.push({
                        _id: element._id,
                        codigo: element.codigo,
                        nombre: element.paterno+' '+element.materno+' '+element.nombre
                    });
                });
                this.dependenciaSel = res.data.dependencias;
                this.puestoSel = res.data.puestos;
                this.localidades = res.data.localidades;
                this.enviando = false;
                // this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.enviando = false;
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
    },
    methods:{
    }
}
</script>